import script from "./employees-list.vue?vue&type=script&setup=true&lang=js"
export * from "./employees-list.vue?vue&type=script&setup=true&lang=js"

import "./employees-list.vue?vue&type=style&index=0&id=4773f3a8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4773f3a8"]])

export default __exports__